export function restbase() {
// return "https://101.52.241.76:8111/api/idv/"
 return "/api/idv/";
//    return "http://111.198.146.40:8165/api/idv/"
}
export function restbase2() {
    return "https://www.advahealth.com.cn:3443/"
//    return "http://111.198.146.40:8165/api/idv/"
}
import CryptoJS from 'crypto-js'
//加密
export function encrypt(word, keyStr){ 
      keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
      var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
      var srcs = CryptoJS.enc.Utf8.parse(word);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      return encrypted.toString();
    }
    //解密
    export function decrypt(word, keyStr){  
      keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
      var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
      var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});

      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
    export const foowwLocalStorage = {
      set: function (key, value) {
          var data = { value: value, expirse: new Date().getTime() };
          localStorage.setItem(key, JSON.stringify(data));
      },
      get: function (key) {
          var data = JSON.parse(localStorage.getItem(key));
          if (data !== null) {
              if (data.expirse != null && data.expirse+7200000 < new Date().getTime()) {
                  localStorage.removeItem(key);
              } else {
                  return data.value;
              }
          }
          return null;
      }
  }